import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import MenuIcon from "@mui/icons-material/Menu";

const Topbar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const username = localStorage.getItem("user_name") || "Usuario";
  const role = (localStorage.getItem("user_type") || "").toLowerCase();

  // ============================
  // LOGOUT
  // ============================
  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/login");
  };

  // ============================
  // CERRAR DROPDOWN
  // ============================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isAdmin = role === "admin" || role === "superadmin";
  const isSuperAdmin = role === "superadmin";

  return (
    <div className="flex justify-between items-center bg-white px-4 md:px-6 py-3 shadow">

      {/* IZQUIERDA */}
      <div className="flex items-center gap-3">

        {/* 🔥 BOTÓN MOBILE FUNCIONAL */}
        <button
          onClick={onMenuClick}
          className="md:hidden text-primary"
        >
          <MenuIcon />
        </button>

        <div className="font-bold text-sm md:text-lg text-primary">
          SISTEMA DE CONTROL DE VISITAS
        </div>
      </div>

      {/* DERECHA */}
      <div className="relative" ref={dropdownRef}>

        <button
          onClick={() => setOpen(!open)}
          className="bg-primary text-white px-3 md:px-4 py-2 rounded-full flex items-center gap-2 hover:bg-accent transition text-sm md:text-base"
        >
          {username}
        </button>

        {open && (
          <div className="absolute right-0 mt-2 w-56 bg-white border rounded-lg shadow-lg z-50">

            <div className="p-3 border-b text-sm">
              <div className="font-semibold">{username}</div>
              <div className="text-gray-500 capitalize">{role}</div>
            </div>

            <button
              onClick={() => {
                navigate("/profile");
                setOpen(false);
              }}
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
            >
              Mi perfil
            </button>

            <button
              onClick={() => {
                navigate("/change-password");
                setOpen(false);
              }}
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
            >
              Cambiar contraseña
            </button>

            {isAdmin && (
              <button
                onClick={() => {
                  navigate("/user");
                  setOpen(false);
                }}
                className="w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Gestión de usuarios
              </button>
            )}

            {isSuperAdmin && (
              <button
                onClick={() => {
                  navigate("/configure");
                  setOpen(false);
                }}
                className="w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Configuración avanzada
              </button>
            )}

            <div className="border-t my-1"></div>

            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
            >
              Cerrar sesión
            </button>

          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;